/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_7741
 */

import { message } from 'ant-design-vue'
import {
  homepage_material_topbanner_v1_add_post,
  homepage_material_topbanner_v1_delete_materialId_delete,
  homepage_material_topbanner_v1_detail_materialId_get,
  homepage_material_topbanner_v1_edit_post,
  homepage_material_topbanner_v1_list_post,
  nav_v2_detail_id_get,
  nav_v2_people_types_get,
  nav_v2_save_post
} from 'server/modules/7741' // 新增top banner
export const homepage_material_topbanner_v1_add_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await homepage_material_topbanner_v1_add_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除top banner
export const homepage_material_topbanner_v1_delete_materialId_delete_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await homepage_material_topbanner_v1_delete_materialId_delete(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// top banner详情
export const homepage_material_topbanner_v1_detail_materialId_get_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await homepage_material_topbanner_v1_detail_materialId_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑top banner
export const homepage_material_topbanner_v1_edit_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await homepage_material_topbanner_v1_edit_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// top banner列表
export const homepage_material_topbanner_v1_list_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await homepage_material_topbanner_v1_list_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 导航详情
export const nav_v2_detail_id_get_ = async function(state) {
  const { success, data, retInfo } = await nav_v2_detail_id_get({
    id: state.postParams.id
  })
  if (success) {
    state.dataAll = [...data]

    if (state.dataAll.length === 1) {
      // state.dataAll[1] = { ...state.resetPostParams }
    } else if (state.dataAll?.length === 2) {
      state.localVisible = true
    }
    const { menuList, navName, navType, subChannel, id, navStyle } = data[0]
    state.menuList = menuList
    // .map(t => {
    //   const urls = t.menuUrl?.split?.('?')
    //   return {
    //     ...t,
    //     addonBefore: urls?.[0],
    //     menuUrl: urls?.[1] ? `?${urls[1]}` : undefined
    //   }
    // })
    if (state.menuList.length) {
      state.checkIndex = 0
      if (state.menuList[state.checkIndex].menuList.length) {
        state.sonCheckIndex = 0
      }
    }
    state.postParams = {
      ...state.postParams,
      id,
      menuList,
      navName,
      navType,
      navStyle,
      subChannel: subChannel - 0
    }
  } else {
    message.error(retInfo)
  }
}

// 获取人群列表
export const nav_v2_people_types_get_ = async function(params) {
  const { success, data, retInfo } = await nav_v2_people_types_get(params)
  if (success) {
    console.log(data)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 保存导航
export const nav_v2_save_post_ = async function(state = {}) {
  let params = {
    ...state.postParams,
    menuList: state.menuList
  }
  if ([null, '', undefined].includes(params.navName)) {
    message.warning('导航名称不能为空！')
    return
  }
  if (!params.id) {
    delete params.id
  }
  const { success, retInfo } = await nav_v2_save_post(state.dataAll)

  if (success) {
    message.success(retInfo)
    state.jumpPage()
  } else {
    message.error('保存失败，则toast提示：“哎呀，系统开小差了，请稍后重试~')
  }
}
